module.exports = {"pathTypes":{"1":"session","2":"team"},"policies":{"User.Create":{"allowed":[1],"result":{"select":["id","pathid","roleid","name","email","login","props"],"restrict":["password"]},"result-1":{"select":"*","group":true}},"Security.Register":{"allowed":[0,1,2],"!roleId-0":2}}}


//////////////////
// WEBPACK FOOTER
// ./app_modules/deloitte-auth-strategy/setup/simgate.json
// module id = ./app_modules/deloitte-auth-strategy/setup/simgate.json
// module chunks = 0